// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   FaUser,
//   FaEnvelope,
//   FaLock,
//   FaGraduationCap,
//   FaIdCard,
//   FaCalendarAlt,
//   FaArrowRight,
//   FaGoogle,
//   FaGithub,
//   FaShieldAlt,
//   FaCheckCircle,
//   FaEye,
//   FaEyeSlash,
//   FaExclamationTriangle,
//   FaRocket,
//   FaStar,
//   FaAward,
// } from "react-icons/fa";
// import { HiOutlineSparkles } from "react-icons/hi";
// import { useDispatch } from "react-redux";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { setUser } from "../store/slices/authSlice";
// import { useFooter } from "../context/FooterContext";

// const Register = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { setShowFooter } = useFooter();
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     password: "",
//     usn: "",
//     branch: "",
//     semester: "",
//     scheme: "2022",
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [isDarkMode, setIsDarkMode] = useState(false);
//   const [passwordStrength, setPasswordStrength] = useState(0);
//   const [isMobile, setIsMobile] = useState(false);
//   const [usnError, setUsnError] = useState("");
//   const [showUsnWarning, setShowUsnWarning] = useState(false);

//   const branches = ["CSE", "ISE", "ECE", "EEE", "MECH", "CIVIL", "AIML", "DS"];
//   const semesters = [1, 2, 3, 4, 5, 6, 7, 8];
//   const schemes = ["2022", "2025"];

//   // Hide footer
//   useEffect(() => {
//     setShowFooter(false);
//     return () => setShowFooter(true);
//   }, [setShowFooter]);

//   // Check dark mode
//   useEffect(() => {
//     const checkDarkMode = () => {
//       const dark =
//         document.documentElement.getAttribute("data-theme") === "dark";
//       setIsDarkMode(dark);
//     };
//     checkDarkMode();
//     const observer = new MutationObserver(checkDarkMode);
//     observer.observe(document.documentElement, {
//       attributes: true,
//       attributeFilter: ["data-theme"],
//     });
//     return () => observer.disconnect();
//   }, []);

//   // Check mobile
//   useEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth <= 768);
//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   // Check password strength
//   useEffect(() => {
//     const password = formData.password;
//     let strength = 0;
//     if (password.length >= 6) strength++;
//     if (password.length >= 8) strength++;
//     if (/[A-Z]/.test(password)) strength++;
//     if (/[0-9]/.test(password)) strength++;
//     if (/[^A-Za-z0-9]/.test(password)) strength++;
//     setPasswordStrength(Math.min(strength, 4));
//   }, [formData.password]);

//   // Validate USN
//   const validateUSN = (usn) => {
//     const usnPattern = /^[0-9]{1}[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{3}$/;
//     if (usn && !usnPattern.test(usn.toUpperCase())) {
//       setUsnError(
//         "Invalid USN format! Format: 1BM21CS001 (1 letter + 2 letters + 2 digits + 2 letters + 3 digits)",
//       );
//       setShowUsnWarning(true);
//       return false;
//     } else {
//       setUsnError("");
//       setShowUsnWarning(false);
//       return true;
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//     if (error) setError("");

//     if (name === "usn") {
//       validateUSN(value);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate USN before submission
//     if (!validateUSN(formData.usn)) {
//       toast.error("Please enter a valid USN format");
//       return;
//     }

//     setLoading(true);
//     setError("");

//     try {
//       const response = await axios.post(
//         "/api/auth/register",
//         formData,
//       );

//       if (response.data.requiresVerification) {
//         toast.success(response.data.message);
//         navigate("/login");
//       } else {
//         localStorage.setItem("token", response.data.token);
//         const userData = {
//           ...response.data.user,
//           _id: response.data.user.id || response.data.user._id,
//         };
//         dispatch(setUser(userData));
//         toast.success("Registration successful!");
//         navigate("/dashboard");
//       }
//     } catch (error) {
//       console.error("Registration error:", error);

//       if (error.response?.data?.errors) {
//         const errorMsg =
//           error.response.data.errors[0]?.msg || "Registration failed";
//         setError(errorMsg);
//         toast.error(errorMsg);
//       } else if (error.response?.data?.message) {
//         setError(error.response.data.message);
//         toast.error(error.response.data.message);
//       } else {
//         setError("Registration failed. Please try again.");
//         toast.error("Registration failed");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getPasswordStrengthColor = () => {
//     if (passwordStrength === 0) return "#ef4444";
//     if (passwordStrength === 1) return "#f59e0b";
//     if (passwordStrength === 2) return "#f59e0b";
//     if (passwordStrength === 3) return "#10b981";
//     return "#10b981";
//   };

//   const getPasswordStrengthText = () => {
//     if (passwordStrength === 0) return "Very Weak";
//     if (passwordStrength === 1) return "Weak";
//     if (passwordStrength === 2) return "Fair";
//     if (passwordStrength === 3) return "Good";
//     return "Strong";
//   };

//   // Helper functions for styling
//   const getTextColor = () => (isDarkMode ? "#f1f5f9" : "#1e293b");
//   const getTextSecondary = () => (isDarkMode ? "#94a3b8" : "#64748b");
//   const getBorderColor = () =>
//     isDarkMode ? "rgba(139,92,246,0.2)" : "rgba(139,92,246,0.1)";
//   const getCardBackground = () =>
//     isDarkMode ? "rgba(30, 30, 45, 0.9)" : "rgba(255, 255, 255, 0.95)";
//   const getInputBackground = () => (isDarkMode ? "rgba(0,0,0,0.3)" : "#ffffff");

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.05,
//         delayChildren: 0.2,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 20, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: { type: "spring", stiffness: 300, damping: 24 },
//     },
//   };

//   return (
//     <div
//       style={{
//         minHeight: "calc(100vh - 200px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: isMobile ? "1rem" : "2rem",
//         background: isDarkMode ? "#0a0a0f" : "#f5f7fb",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* Animated Background Grid */}
//       <div
//         style={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           pointerEvents: "none",
//           zIndex: 0,
//           backgroundImage: `radial-gradient(circle at 1px 1px, ${isDarkMode ? "rgba(139,92,246,0.1)" : "rgba(139,92,246,0.08)"} 1px, transparent 1px)`,
//           backgroundSize: "40px 40px",
//         }}
//       />

//       {/* Floating Gradient Orbs */}
//       <motion.div
//         animate={{ x: [0, 100, 0], y: [0, 50, 0] }}
//         transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
//         style={{
//           position: "fixed",
//           top: "10%",
//           left: "-5%",
//           width: "250px",
//           height: "250px",
//           background:
//             "radial-gradient(circle, rgba(139,92,246,0.3) 0%, transparent 70%)",
//           borderRadius: "50%",
//           filter: "blur(60px)",
//           pointerEvents: "none",
//           zIndex: 0,
//         }}
//       />
//       <motion.div
//         animate={{ x: [0, -100, 0], y: [0, 80, 0] }}
//         transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
//         style={{
//           position: "fixed",
//           bottom: "10%",
//           right: "-5%",
//           width: "300px",
//           height: "300px",
//           background:
//             "radial-gradient(circle, rgba(59,130,246,0.3) 0%, transparent 70%)",
//           borderRadius: "50%",
//           filter: "blur(60px)",
//           pointerEvents: "none",
//           zIndex: 0,
//         }}
//       />

//       <motion.div
//         variants={containerVariants}
//         initial="hidden"
//         animate="visible"
//         style={{
//           maxWidth: "560px",
//           width: "100%",
//           background: getCardBackground(),
//           backdropFilter: "blur(20px)",
//           borderRadius: "32px",
//           padding: isMobile ? "1.5rem" : "2.5rem",
//           boxShadow: isDarkMode
//             ? "0 25px 50px -12px rgba(0,0,0,0.5)"
//             : "0 25px 50px -12px rgba(0,0,0,0.25)",
//           border: `1px solid ${getBorderColor()}`,
//           position: "relative",
//           zIndex: 1,
//           maxHeight: "90vh",
//           overflowY: "auto",
//         }}
//       >
//         {/* Custom scrollbar styles */}
//         <style>
//           {`
//             .custom-scroll::-webkit-scrollbar {
//               width: 6px;
//             }
//             .custom-scroll::-webkit-scrollbar-track {
//               background: ${isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"};
//               border-radius: 10px;
//             }
//             .custom-scroll::-webkit-scrollbar-thumb {
//               background: linear-gradient(135deg, #8b5cf6, #3b82f6);
//               border-radius: 10px;
//             }
//           `}
//         </style>

//         {/* Animated gradient border top */}
//         <motion.div
//           animate={{
//             background: [
//               "linear-gradient(90deg, #8b5cf6, #3b82f6, #06b6d4, #8b5cf6)",
//               "linear-gradient(90deg, #3b82f6, #06b6d4, #8b5cf6, #3b82f6)",
//             ],
//           }}
//           transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             height: "4px",
//             borderRadius: "32px 32px 0 0",
//           }}
//         />

//         {/* Header with Illustration */}
//         <motion.div
//           variants={itemVariants}
//           style={{ textAlign: "center", marginBottom: "2rem" }}
//         >
//           <motion.div
//             animate={{ y: [0, -10, 0] }}
//             transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               justifyContent: "center",
//               marginBottom: "1rem",
//             }}
//           >
//             <div
//               style={{
//                 background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
//                 width: "70px",
//                 height: "70px",
//                 borderRadius: "24px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 boxShadow: "0 20px 40px -12px rgba(139,92,246,0.4)",
//               }}
//             >
//               <FaRocket size={32} color="white" />
//             </div>
//           </motion.div>
//           <h1
//             style={{
//               fontSize: isMobile ? "1.8rem" : "2rem",
//               marginBottom: "0.5rem",
//               background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
//               WebkitBackgroundClip: "text",
//               WebkitTextFillColor: "transparent",
//               fontWeight: 700,
//             }}
//           >
//             Join VTUGenX
//           </h1>
//           <p style={{ color: getTextSecondary() }}>
//             Create your account and start learning
//           </p>
//         </motion.div>

//         {/* Error Message Display */}
//         <AnimatePresence>
//           {error && (
//             <motion.div
//               initial={{ opacity: 0, y: -10 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -10 }}
//               style={{
//                 background: "rgba(239, 68, 68, 0.1)",
//                 color: "#ef4444",
//                 padding: "0.8rem 1rem",
//                 borderRadius: "16px",
//                 marginBottom: "1.5rem",
//                 fontSize: "0.85rem",
//                 textAlign: "center",
//                 border: "1px solid rgba(239, 68, 68, 0.3)",
//               }}
//             >
//               {error}
//             </motion.div>
//           )}
//         </AnimatePresence>

//         <form onSubmit={handleSubmit} className="custom-scroll">
//           {/* Full Name */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaUser style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
//               Full Name
//             </label>
//             <input
//               type="text"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               required
//               placeholder="Enter your full name"
//               style={{
//                 width: "100%",
//                 padding: "0.9rem 1rem",
//                 border: `2px solid ${error ? "#ef4444" : getBorderColor()}`,
//                 borderRadius: "16px",
//                 outline: "none",
//                 fontSize: "1rem",
//                 transition: "all 0.3s",
//                 backgroundColor: getInputBackground(),
//                 color: getTextColor(),
//               }}
//               onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//               onBlur={(e) => {
//                 if (!error) {
//                   e.target.style.borderColor = getBorderColor();
//                 }
//               }}
//             />
//           </motion.div>

//           {/* Email */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaEnvelope style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
//               Email Address
//             </label>
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               required
//               placeholder="Enter your email"
//               style={{
//                 width: "100%",
//                 padding: "0.9rem 1rem",
//                 border: `2px solid ${error ? "#ef4444" : getBorderColor()}`,
//                 borderRadius: "16px",
//                 outline: "none",
//                 fontSize: "1rem",
//                 transition: "all 0.3s",
//                 backgroundColor: getInputBackground(),
//                 color: getTextColor(),
//               }}
//               onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//               onBlur={(e) => {
//                 if (!error) {
//                   e.target.style.borderColor = getBorderColor();
//                 }
//               }}
//             />
//           </motion.div>

//           {/* Password */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaLock style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
//               Password
//             </label>
//             <div style={{ position: "relative" }}>
//               <input
//                 type={showPassword ? "text" : "password"}
//                 name="password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 placeholder="Create a password (min. 6 characters)"
//                 style={{
//                   width: "100%",
//                   padding: "0.9rem 1rem",
//                   paddingRight: "3rem",
//                   border: `2px solid ${error ? "#ef4444" : getBorderColor()}`,
//                   borderRadius: "16px",
//                   outline: "none",
//                   fontSize: "1rem",
//                   transition: "all 0.3s",
//                   backgroundColor: getInputBackground(),
//                   color: getTextColor(),
//                 }}
//                 onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//                 onBlur={(e) => {
//                   if (!error) {
//                     e.target.style.borderColor = getBorderColor();
//                   }
//                 }}
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowPassword(!showPassword)}
//                 style={{
//                   position: "absolute",
//                   right: "12px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   background: "none",
//                   border: "none",
//                   cursor: "pointer",
//                   color: getTextSecondary(),
//                 }}
//               >
//                 {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
//               </button>
//             </div>

//             {/* Password Strength Indicator */}
//             {formData.password && (
//               <motion.div
//                 initial={{ opacity: 0, height: 0 }}
//                 animate={{ opacity: 1, height: "auto" }}
//                 style={{ marginTop: "0.5rem" }}
//               >
//                 <div
//                   style={{
//                     height: "4px",
//                     background: isDarkMode
//                       ? "rgba(255,255,255,0.1)"
//                       : "#e2e8f0",
//                     borderRadius: "2px",
//                     overflow: "hidden",
//                   }}
//                 >
//                   <motion.div
//                     initial={{ width: 0 }}
//                     animate={{ width: `${(passwordStrength / 4) * 100}%` }}
//                     transition={{ duration: 0.3 }}
//                     style={{
//                       height: "100%",
//                       background: getPasswordStrengthColor(),
//                     }}
//                   />
//                 </div>
//                 <p
//                   style={{
//                     fontSize: "0.7rem",
//                     color: getPasswordStrengthColor(),
//                     marginTop: "0.25rem",
//                   }}
//                 >
//                   Password strength: {getPasswordStrengthText()}
//                 </p>
//               </motion.div>
//             )}
//           </motion.div>

//           {/* USN with Warning */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaIdCard style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
//               USN (University Seat Number)
//             </label>
//             <div style={{ position: "relative" }}>
//               <input
//                 type="text"
//                 name="usn"
//                 value={formData.usn}
//                 onChange={handleChange}
//                 required
//                 placeholder="e.g., 1BM21CS001"
//                 style={{
//                   width: "100%",
//                   padding: "0.9rem 1rem",
//                   border: `2px solid ${usnError ? "#ef4444" : error ? "#ef4444" : getBorderColor()}`,
//                   borderRadius: "16px",
//                   outline: "none",
//                   fontSize: "1rem",
//                   transition: "all 0.3s",
//                   backgroundColor: getInputBackground(),
//                   color: getTextColor(),
//                   textTransform: "uppercase",
//                 }}
//                 onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//                 onBlur={(e) => {
//                   if (!usnError && !error) {
//                     e.target.style.borderColor = getBorderColor();
//                   }
//                 }}
//               />
//               {usnError && (
//                 <div
//                   style={{
//                     position: "absolute",
//                     right: "12px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#ef4444",
//                   }}
//                 >
//                   <FaExclamationTriangle size={16} />
//                 </div>
//               )}
//             </div>

//             {/* USN Warning Message */}
//             <AnimatePresence>
//               {showUsnWarning && usnError && (
//                 <motion.div
//                   initial={{ opacity: 0, y: -10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   exit={{ opacity: 0, y: -10 }}
//                   style={{
//                     marginTop: "0.5rem",
//                     padding: "0.5rem 0.75rem",
//                     background: "rgba(239, 68, 68, 0.1)",
//                     borderRadius: "12px",
//                     borderLeft: "3px solid #ef4444",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.5rem",
//                     }}
//                   >
//                     <FaExclamationTriangle size={12} color="#ef4444" />
//                     <span style={{ fontSize: "0.7rem", color: "#ef4444" }}>
//                       {usnError}
//                     </span>
//                   </div>
//                   <p
//                     style={{
//                       fontSize: "0.65rem",
//                       color: getTextSecondary(),
//                       marginTop: "0.3rem",
//                       marginLeft: "1.2rem",
//                     }}
//                   >
//                     Example: 1BM21CS001 (1 digit + 2 letters + 2 digits + 2
//                     letters + 3 digits)
//                   </p>
//                 </motion.div>
//               )}
//             </AnimatePresence>

//             {/* Info note about USN */}
//             <p
//               style={{
//                 fontSize: "0.65rem",
//                 color: getTextSecondary(),
//                 marginTop: "0.3rem",
//               }}
//             >
//               <FaExclamationTriangle
//                 size={10}
//                 style={{ marginRight: "0.3rem", color: "#f59e0b" }}
//               />{" "}
//               Enter your USN carefully. You cannot modify it later.
//             </p>
//           </motion.div>

//           {/* Branch and Semester */}
//           <motion.div
//             variants={itemVariants}
//             style={{
//               display: "grid",
//               gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
//               gap: "1rem",
//               marginBottom: "1.5rem",
//             }}
//           >
//             <div>
//               <label
//                 style={{
//                   display: "block",
//                   marginBottom: "0.5rem",
//                   color: getTextSecondary(),
//                   fontWeight: 500,
//                   fontSize: "0.875rem",
//                 }}
//               >
//                 <FaGraduationCap
//                   style={{ marginRight: "0.5rem", color: "#8b5cf6" }}
//                 />
//                 Branch
//               </label>
//               <select
//                 name="branch"
//                 value={formData.branch}
//                 onChange={handleChange}
//                 required
//                 style={{
//                   width: "100%",
//                   padding: "0.9rem 1rem",
//                   border: `2px solid ${getBorderColor()}`,
//                   borderRadius: "16px",
//                   outline: "none",
//                   fontSize: "1rem",
//                   backgroundColor: getInputBackground(),
//                   color: getTextColor(),
//                   cursor: "pointer",
//                 }}
//                 onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//                 onBlur={(e) => (e.target.style.borderColor = getBorderColor())}
//               >
//                 <option value="">Select Branch</option>
//                 {branches.map((branch) => (
//                   <option key={branch} value={branch}>
//                     {branch}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div>
//               <label
//                 style={{
//                   display: "block",
//                   marginBottom: "0.5rem",
//                   color: getTextSecondary(),
//                   fontWeight: 500,
//                   fontSize: "0.875rem",
//                 }}
//               >
//                 <FaGraduationCap
//                   style={{ marginRight: "0.5rem", color: "#8b5cf6" }}
//                 />
//                 Semester
//               </label>
//               <select
//                 name="semester"
//                 value={formData.semester}
//                 onChange={handleChange}
//                 required
//                 style={{
//                   width: "100%",
//                   padding: "0.9rem 1rem",
//                   border: `2px solid ${getBorderColor()}`,
//                   borderRadius: "16px",
//                   outline: "none",
//                   fontSize: "1rem",
//                   backgroundColor: getInputBackground(),
//                   color: getTextColor(),
//                   cursor: "pointer",
//                 }}
//                 onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//                 onBlur={(e) => (e.target.style.borderColor = getBorderColor())}
//               >
//                 <option value="">Select Semester</option>
//                 {semesters.map((sem) => (
//                   <option key={sem} value={sem}>
//                     Semester {sem}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </motion.div>

//           {/* Scheme Dropdown */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaCalendarAlt
//                 style={{ marginRight: "0.5rem", color: "#8b5cf6" }}
//               />
//               Scheme
//             </label>
//             <select
//               name="scheme"
//               value={formData.scheme}
//               onChange={handleChange}
//               required
//               style={{
//                 width: "100%",
//                 padding: "0.9rem 1rem",
//                 border: `2px solid ${getBorderColor()}`,
//                 borderRadius: "16px",
//                 outline: "none",
//                 fontSize: "1rem",
//                 backgroundColor: getInputBackground(),
//                 color: getTextColor(),
//                 cursor: "pointer",
//               }}
//               onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//               onBlur={(e) => (e.target.style.borderColor = getBorderColor())}
//             >
//               <option value="">Select Scheme</option>
//               {schemes.map((scheme) => (
//                 <option key={scheme} value={scheme}>
//                   {scheme === "2022" ? "CBCS 2022 Scheme" : "CBCS 2025 Scheme"}
//                 </option>
//               ))}
//             </select>
//           </motion.div>

//           {/* Verification Notice */}
//           <motion.div
//             variants={itemVariants}
//             style={{
//               marginTop: "1rem",
//               padding: "1rem",
//               background: isDarkMode
//                 ? "rgba(139,92,246,0.1)"
//                 : "rgba(139,92,246,0.05)",
//               borderRadius: "16px",
//               border: `1px solid ${getBorderColor()}`,
//             }}
//           >
//             <div
//               style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
//             >
//               <div
//                 style={{
//                   width: "24px",
//                   height: "24px",
//                   background: "rgba(16,185,129,0.1)",
//                   borderRadius: "8px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <FaCheckCircle color="#10b981" size={12} />
//               </div>
//               <p
//                 style={{
//                   color: getTextSecondary(),
//                   fontSize: "0.75rem",
//                   margin: 0,
//                 }}
//               >
//                 After registration, you'll receive a verification email. Please
//                 check your inbox.
//               </p>
//             </div>
//           </motion.div>

//           {/* Submit Button */}
//           <motion.button
//             variants={itemVariants}
//             type="submit"
//             disabled={loading}
//             whileHover={{ scale: loading ? 1 : 1.02 }}
//             whileTap={{ scale: loading ? 1 : 0.98 }}
//             style={{
//               width: "100%",
//               padding: "1rem",
//               marginTop: "2rem",
//               background: loading
//                 ? "#94a3b8"
//                 : "linear-gradient(135deg, #8b5cf6, #3b82f6)",
//               color: "white",
//               border: "none",
//               borderRadius: "16px",
//               fontSize: "1rem",
//               fontWeight: 600,
//               cursor: loading ? "not-allowed" : "pointer",
//               transition: "all 0.3s",
//               boxShadow: loading ? "none" : "0 4px 14px 0 rgba(139,92,246,0.4)",
//             }}
//           >
//             {loading ? "Creating Account..." : "Create Account"}
//           </motion.button>
//         </form>

//         {/* Divider */}
//         <motion.div
//           variants={itemVariants}
//           style={{
//             margin: "1.5rem 0",
//             position: "relative",
//             textAlign: "center",
//           }}
//         >
//           <div
//             style={{
//               position: "absolute",
//               top: "50%",
//               left: 0,
//               right: 0,
//               height: "1px",
//               background: getBorderColor(),
//             }}
//           />
//         </motion.div>

//         {/* Login Link */}
//         <motion.div variants={itemVariants} style={{ textAlign: "center" }}>
//           <p style={{ color: getTextSecondary(), fontSize: "0.875rem" }}>
//             Already have an account?{" "}
//             <Link
//               to="/login"
//               style={{
//                 color: "#8b5cf6",
//                 textDecoration: "none",
//                 fontWeight: 600,
//                 transition: "color 0.3s",
//               }}
//               onMouseEnter={(e) => (e.target.style.color = "#3b82f6")}
//               onMouseLeave={(e) => (e.target.style.color = "#8b5cf6")}
//             >
//               Login here
//               <FaArrowRight
//                 style={{
//                   marginLeft: "0.3rem",
//                   fontSize: "0.7rem",
//                   display: "inline",
//                 }}
//               />
//             </Link>
//           </p>
//         </motion.div>

//         {/* Security Badge */}
//         <motion.div
//           variants={itemVariants}
//           style={{
//             marginTop: "1.5rem",
//             paddingTop: "1rem",
//             borderTop: `1px solid ${getBorderColor()}`,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "0.5rem",
//             flexWrap: "wrap",
//           }}
//         >
//           <FaShieldAlt size={12} color="#10b981" />
//           <span style={{ color: getTextSecondary(), fontSize: "0.7rem" }}>
//             Your data is protected with 256-bit encryption
//           </span>
//           <FaStar size={10} color="#f59e0b" />
//         </motion.div>
//       </motion.div>

//       <style>
//         {`
//           @keyframes spin {
//             from { transform: rotate(0deg); }
//             to { transform: rotate(360deg); }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default Register;

// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   FaUser,
//   FaEnvelope,
//   FaLock,
//   FaGraduationCap,
//   FaIdCard,
//   FaCalendarAlt,
//   FaArrowRight,
//   FaGoogle,
//   FaGithub,
//   FaShieldAlt,
//   FaCheckCircle,
//   FaEye,
//   FaEyeSlash,
//   FaExclamationTriangle,
//   FaRocket,
//   FaStar,
//   FaAward,
// } from "react-icons/fa";
// import { HiOutlineSparkles } from "react-icons/hi";
// import { useDispatch } from "react-redux";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { setUser } from "../store/slices/authSlice";
// import { useFooter } from "../context/FooterContext";

// const Register = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { setShowFooter } = useFooter();
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     password: "",
//     usn: "",
//     branch: "",
//     semester: "",
//     scheme: "2022",
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [isDarkMode, setIsDarkMode] = useState(false);
//   const [passwordStrength, setPasswordStrength] = useState(0);
//   const [isMobile, setIsMobile] = useState(false);
//   const [usnError, setUsnError] = useState("");
//   const [showUsnWarning, setShowUsnWarning] = useState(false);

//   const branches = ["CSE", "ISE", "ECE", "EEE", "MECH", "CIVIL", "AIML", "DS"];
//   const semesters = [1, 2, 3, 4, 5, 6, 7, 8];
//   const schemes = ["2022", "2025"];

//   // Hide footer
//   useEffect(() => {
//     setShowFooter(false);
//     return () => setShowFooter(true);
//   }, [setShowFooter]);

//   // Check dark mode
//   useEffect(() => {
//     const checkDarkMode = () => {
//       const dark =
//         document.documentElement.getAttribute("data-theme") === "dark";
//       setIsDarkMode(dark);
//     };
//     checkDarkMode();
//     const observer = new MutationObserver(checkDarkMode);
//     observer.observe(document.documentElement, {
//       attributes: true,
//       attributeFilter: ["data-theme"],
//     });
//     return () => observer.disconnect();
//   }, []);

//   // Check mobile
//   useEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth <= 768);
//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   // Check password strength
//   useEffect(() => {
//     const password = formData.password;
//     let strength = 0;
//     if (password.length >= 6) strength++;
//     if (password.length >= 8) strength++;
//     if (/[A-Z]/.test(password)) strength++;
//     if (/[0-9]/.test(password)) strength++;
//     if (/[^A-Za-z0-9]/.test(password)) strength++;
//     setPasswordStrength(Math.min(strength, 4));
//   }, [formData.password]);

//   // Validate USN
//   const validateUSN = (usn) => {
//     const usnPattern = /^[0-9]{1}[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{3}$/;
//     if (usn && !usnPattern.test(usn.toUpperCase())) {
//       setUsnError(
//         "Invalid USN format! Format: 1BM21CS001 (1 letter + 2 letters + 2 digits + 2 letters + 3 digits)",
//       );
//       setShowUsnWarning(true);
//       return false;
//     } else {
//       setUsnError("");
//       setShowUsnWarning(false);
//       return true;
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//     if (error) setError("");

//     if (name === "usn") {
//       validateUSN(value);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate USN before submission
//     if (!validateUSN(formData.usn)) {
//       toast.error("Please enter a valid USN format");
//       return;
//     }

//     setLoading(true);
//     setError("");

//     try {
//       const response = await axios.post(
//         "http://localhost:5001/api/auth/register",
//         formData,
//       );

//       if (response.data.requiresVerification) {
//         toast.success(response.data.message);
//         navigate("/login");
//       } else {
//         localStorage.setItem("token", response.data.token);
//         const userData = {
//           ...response.data.user,
//           _id: response.data.user.id || response.data.user._id,
//         };
//         dispatch(setUser(userData));
//         toast.success("Registration successful!");
//         navigate("/dashboard");
//       }
//     } catch (error) {
//       console.error("Registration error:", error);

//       if (error.response?.data?.errors) {
//         const errorMsg =
//           error.response.data.errors[0]?.msg || "Registration failed";
//         setError(errorMsg);
//         toast.error(errorMsg);
//       } else if (error.response?.data?.message) {
//         setError(error.response.data.message);
//         toast.error(error.response.data.message);
//       } else {
//         setError("Registration failed. Please try again.");
//         toast.error("Registration failed");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getPasswordStrengthColor = () => {
//     if (passwordStrength === 0) return "#ef4444";
//     if (passwordStrength === 1) return "#f59e0b";
//     if (passwordStrength === 2) return "#f59e0b";
//     if (passwordStrength === 3) return "#10b981";
//     return "#10b981";
//   };

//   const getPasswordStrengthText = () => {
//     if (passwordStrength === 0) return "Very Weak";
//     if (passwordStrength === 1) return "Weak";
//     if (passwordStrength === 2) return "Fair";
//     if (passwordStrength === 3) return "Good";
//     return "Strong";
//   };

//   // Helper functions for styling
//   const getTextColor = () => (isDarkMode ? "#f1f5f9" : "#1e293b");
//   const getTextSecondary = () => (isDarkMode ? "#94a3b8" : "#64748b");
//   const getBorderColor = () =>
//     isDarkMode ? "rgba(139,92,246,0.2)" : "rgba(139,92,246,0.1)";
//   const getCardBackground = () =>
//     isDarkMode ? "rgba(30, 30, 45, 0.9)" : "rgba(255, 255, 255, 0.95)";
//   const getInputBackground = () => (isDarkMode ? "rgba(0,0,0,0.3)" : "#ffffff");

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.05,
//         delayChildren: 0.2,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 20, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: { type: "spring", stiffness: 300, damping: 24 },
//     },
//   };

//   return (
//     <div
//       style={{
//         minHeight: "calc(100vh - 200px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: isMobile ? "1rem" : "2rem",
//         background: isDarkMode ? "#0a0a0f" : "#f5f7fb",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* Animated Background Grid */}
//       <div
//         style={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           pointerEvents: "none",
//           zIndex: 0,
//           backgroundImage: `radial-gradient(circle at 1px 1px, ${isDarkMode ? "rgba(139,92,246,0.1)" : "rgba(139,92,246,0.08)"} 1px, transparent 1px)`,
//           backgroundSize: "40px 40px",
//         }}
//       />

//       {/* Floating Gradient Orbs */}
//       <motion.div
//         animate={{ x: [0, 100, 0], y: [0, 50, 0] }}
//         transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
//         style={{
//           position: "fixed",
//           top: "10%",
//           left: "-5%",
//           width: "250px",
//           height: "250px",
//           background:
//             "radial-gradient(circle, rgba(139,92,246,0.3) 0%, transparent 70%)",
//           borderRadius: "50%",
//           filter: "blur(60px)",
//           pointerEvents: "none",
//           zIndex: 0,
//         }}
//       />
//       <motion.div
//         animate={{ x: [0, -100, 0], y: [0, 80, 0] }}
//         transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
//         style={{
//           position: "fixed",
//           bottom: "10%",
//           right: "-5%",
//           width: "300px",
//           height: "300px",
//           background:
//             "radial-gradient(circle, rgba(59,130,246,0.3) 0%, transparent 70%)",
//           borderRadius: "50%",
//           filter: "blur(60px)",
//           pointerEvents: "none",
//           zIndex: 0,
//         }}
//       />

//       <motion.div
//         variants={containerVariants}
//         initial="hidden"
//         animate="visible"
//         style={{
//           maxWidth: "560px",
//           width: "100%",
//           background: getCardBackground(),
//           backdropFilter: "blur(20px)",
//           borderRadius: "32px",
//           padding: isMobile ? "1.5rem" : "2.5rem",
//           boxShadow: isDarkMode
//             ? "0 25px 50px -12px rgba(0,0,0,0.5)"
//             : "0 25px 50px -12px rgba(0,0,0,0.25)",
//           border: `1px solid ${getBorderColor()}`,
//           position: "relative",
//           zIndex: 1,
//           maxHeight: "90vh",
//           overflowY: "auto",
//         }}
//       >
//         {/* Custom scrollbar styles */}
//         <style>
//           {`
//             .custom-scroll::-webkit-scrollbar {
//               width: 6px;
//             }
//             .custom-scroll::-webkit-scrollbar-track {
//               background: ${isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"};
//               border-radius: 10px;
//             }
//             .custom-scroll::-webkit-scrollbar-thumb {
//               background: linear-gradient(135deg, #8b5cf6, #3b82f6);
//               border-radius: 10px;
//             }
//           `}
//         </style>

//         {/* Animated gradient border top */}
//         <motion.div
//           animate={{
//             background: [
//               "linear-gradient(90deg, #8b5cf6, #3b82f6, #06b6d4, #8b5cf6)",
//               "linear-gradient(90deg, #3b82f6, #06b6d4, #8b5cf6, #3b82f6)",
//             ],
//           }}
//           transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             height: "4px",
//             borderRadius: "32px 32px 0 0",
//           }}
//         />

//         {/* Header with Illustration */}
//         <motion.div
//           variants={itemVariants}
//           style={{ textAlign: "center", marginBottom: "2rem" }}
//         >
//           <motion.div
//             animate={{ y: [0, -10, 0] }}
//             transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               justifyContent: "center",
//               marginBottom: "1rem",
//             }}
//           >
//             <div
//               style={{
//                 background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
//                 width: "70px",
//                 height: "70px",
//                 borderRadius: "24px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 boxShadow: "0 20px 40px -12px rgba(139,92,246,0.4)",
//               }}
//             >
//               <FaRocket size={32} color="white" />
//             </div>
//           </motion.div>
//           <h1
//             style={{
//               fontSize: isMobile ? "1.8rem" : "2rem",
//               marginBottom: "0.5rem",
//               background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
//               WebkitBackgroundClip: "text",
//               WebkitTextFillColor: "transparent",
//               fontWeight: 700,
//             }}
//           >
//             Join VTUGenX
//           </h1>
//           <p style={{ color: getTextSecondary() }}>
//             Create your account and start learning
//           </p>
//         </motion.div>

//         {/* Error Message Display */}
//         <AnimatePresence>
//           {error && (
//             <motion.div
//               initial={{ opacity: 0, y: -10 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -10 }}
//               style={{
//                 background: "rgba(239, 68, 68, 0.1)",
//                 color: "#ef4444",
//                 padding: "0.8rem 1rem",
//                 borderRadius: "16px",
//                 marginBottom: "1.5rem",
//                 fontSize: "0.85rem",
//                 textAlign: "center",
//                 border: "1px solid rgba(239, 68, 68, 0.3)",
//               }}
//             >
//               {error}
//             </motion.div>
//           )}
//         </AnimatePresence>

//         <form onSubmit={handleSubmit} className="custom-scroll">
//           {/* Full Name */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaUser style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
//               Full Name
//             </label>
//             <input
//               type="text"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               required
//               placeholder="Enter your full name"
//               style={{
//                 width: "100%",
//                 padding: "0.9rem 1rem",
//                 border: `2px solid ${error ? "#ef4444" : getBorderColor()}`,
//                 borderRadius: "16px",
//                 outline: "none",
//                 fontSize: "1rem",
//                 transition: "all 0.3s",
//                 backgroundColor: getInputBackground(),
//                 color: getTextColor(),
//               }}
//               onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//               onBlur={(e) => {
//                 if (!error) {
//                   e.target.style.borderColor = getBorderColor();
//                 }
//               }}
//             />
//           </motion.div>

//           {/* Email */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaEnvelope style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
//               Email Address
//             </label>
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               required
//               placeholder="Enter your email"
//               style={{
//                 width: "100%",
//                 padding: "0.9rem 1rem",
//                 border: `2px solid ${error ? "#ef4444" : getBorderColor()}`,
//                 borderRadius: "16px",
//                 outline: "none",
//                 fontSize: "1rem",
//                 transition: "all 0.3s",
//                 backgroundColor: getInputBackground(),
//                 color: getTextColor(),
//               }}
//               onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//               onBlur={(e) => {
//                 if (!error) {
//                   e.target.style.borderColor = getBorderColor();
//                 }
//               }}
//             />
//           </motion.div>

//           {/* Password */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaLock style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
//               Password
//             </label>
//             <div style={{ position: "relative" }}>
//               <input
//                 type={showPassword ? "text" : "password"}
//                 name="password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 placeholder="Create a password (min. 6 characters)"
//                 style={{
//                   width: "100%",
//                   padding: "0.9rem 1rem",
//                   paddingRight: "3rem",
//                   border: `2px solid ${error ? "#ef4444" : getBorderColor()}`,
//                   borderRadius: "16px",
//                   outline: "none",
//                   fontSize: "1rem",
//                   transition: "all 0.3s",
//                   backgroundColor: getInputBackground(),
//                   color: getTextColor(),
//                 }}
//                 onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//                 onBlur={(e) => {
//                   if (!error) {
//                     e.target.style.borderColor = getBorderColor();
//                   }
//                 }}
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowPassword(!showPassword)}
//                 style={{
//                   position: "absolute",
//                   right: "12px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   background: "none",
//                   border: "none",
//                   cursor: "pointer",
//                   color: getTextSecondary(),
//                 }}
//               >
//                 {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
//               </button>
//             </div>

//             {/* Password Strength Indicator */}
//             {formData.password && (
//               <motion.div
//                 initial={{ opacity: 0, height: 0 }}
//                 animate={{ opacity: 1, height: "auto" }}
//                 style={{ marginTop: "0.5rem" }}
//               >
//                 <div
//                   style={{
//                     height: "4px",
//                     background: isDarkMode
//                       ? "rgba(255,255,255,0.1)"
//                       : "#e2e8f0",
//                     borderRadius: "2px",
//                     overflow: "hidden",
//                   }}
//                 >
//                   <motion.div
//                     initial={{ width: 0 }}
//                     animate={{ width: `${(passwordStrength / 4) * 100}%` }}
//                     transition={{ duration: 0.3 }}
//                     style={{
//                       height: "100%",
//                       background: getPasswordStrengthColor(),
//                     }}
//                   />
//                 </div>
//                 <p
//                   style={{
//                     fontSize: "0.7rem",
//                     color: getPasswordStrengthColor(),
//                     marginTop: "0.25rem",
//                   }}
//                 >
//                   Password strength: {getPasswordStrengthText()}
//                 </p>
//               </motion.div>
//             )}
//           </motion.div>

//           {/* USN with Warning */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaIdCard style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
//               USN (University Seat Number)
//             </label>
//             <div style={{ position: "relative" }}>
//               <input
//                 type="text"
//                 name="usn"
//                 value={formData.usn}
//                 onChange={handleChange}
//                 required
//                 placeholder="e.g., 1BM21CS001"
//                 style={{
//                   width: "100%",
//                   padding: "0.9rem 1rem",
//                   border: `2px solid ${usnError ? "#ef4444" : error ? "#ef4444" : getBorderColor()}`,
//                   borderRadius: "16px",
//                   outline: "none",
//                   fontSize: "1rem",
//                   transition: "all 0.3s",
//                   backgroundColor: getInputBackground(),
//                   color: getTextColor(),
//                   textTransform: "uppercase",
//                 }}
//                 onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//                 onBlur={(e) => {
//                   if (!usnError && !error) {
//                     e.target.style.borderColor = getBorderColor();
//                   }
//                 }}
//               />
//               {usnError && (
//                 <div
//                   style={{
//                     position: "absolute",
//                     right: "12px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#ef4444",
//                   }}
//                 >
//                   <FaExclamationTriangle size={16} />
//                 </div>
//               )}
//             </div>

//             {/* USN Warning Message */}
//             <AnimatePresence>
//               {showUsnWarning && usnError && (
//                 <motion.div
//                   initial={{ opacity: 0, y: -10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   exit={{ opacity: 0, y: -10 }}
//                   style={{
//                     marginTop: "0.5rem",
//                     padding: "0.5rem 0.75rem",
//                     background: "rgba(239, 68, 68, 0.1)",
//                     borderRadius: "12px",
//                     borderLeft: "3px solid #ef4444",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.5rem",
//                     }}
//                   >
//                     <FaExclamationTriangle size={12} color="#ef4444" />
//                     <span style={{ fontSize: "0.7rem", color: "#ef4444" }}>
//                       {usnError}
//                     </span>
//                   </div>
//                   <p
//                     style={{
//                       fontSize: "0.65rem",
//                       color: getTextSecondary(),
//                       marginTop: "0.3rem",
//                       marginLeft: "1.2rem",
//                     }}
//                   >
//                     Example: 1BM21CS001 (1 digit + 2 letters + 2 digits + 2
//                     letters + 3 digits)
//                   </p>
//                 </motion.div>
//               )}
//             </AnimatePresence>

//             {/* Info note about USN */}
//             <p
//               style={{
//                 fontSize: "0.65rem",
//                 color: getTextSecondary(),
//                 marginTop: "0.3rem",
//               }}
//             >
//               <FaExclamationTriangle
//                 size={10}
//                 style={{ marginRight: "0.3rem", color: "#f59e0b" }}
//               />{" "}
//               Enter your USN carefully. You cannot modify it later.
//             </p>
//           </motion.div>

//           {/* Branch and Semester */}
//           <motion.div
//             variants={itemVariants}
//             style={{
//               display: "grid",
//               gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
//               gap: "1rem",
//               marginBottom: "1.5rem",
//             }}
//           >
//             <div>
//               <label
//                 style={{
//                   display: "block",
//                   marginBottom: "0.5rem",
//                   color: getTextSecondary(),
//                   fontWeight: 500,
//                   fontSize: "0.875rem",
//                 }}
//               >
//                 <FaGraduationCap
//                   style={{ marginRight: "0.5rem", color: "#8b5cf6" }}
//                 />
//                 Branch
//               </label>
//               <select
//                 name="branch"
//                 value={formData.branch}
//                 onChange={handleChange}
//                 required
//                 style={{
//                   width: "100%",
//                   padding: "0.9rem 1rem",
//                   border: `2px solid ${getBorderColor()}`,
//                   borderRadius: "16px",
//                   outline: "none",
//                   fontSize: "1rem",
//                   backgroundColor: getInputBackground(),
//                   color: getTextColor(),
//                   cursor: "pointer",
//                 }}
//                 onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//                 onBlur={(e) => (e.target.style.borderColor = getBorderColor())}
//               >
//                 <option value="">Select Branch</option>
//                 {branches.map((branch) => (
//                   <option key={branch} value={branch}>
//                     {branch}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div>
//               <label
//                 style={{
//                   display: "block",
//                   marginBottom: "0.5rem",
//                   color: getTextSecondary(),
//                   fontWeight: 500,
//                   fontSize: "0.875rem",
//                 }}
//               >
//                 <FaGraduationCap
//                   style={{ marginRight: "0.5rem", color: "#8b5cf6" }}
//                 />
//                 Semester
//               </label>
//               <select
//                 name="semester"
//                 value={formData.semester}
//                 onChange={handleChange}
//                 required
//                 style={{
//                   width: "100%",
//                   padding: "0.9rem 1rem",
//                   border: `2px solid ${getBorderColor()}`,
//                   borderRadius: "16px",
//                   outline: "none",
//                   fontSize: "1rem",
//                   backgroundColor: getInputBackground(),
//                   color: getTextColor(),
//                   cursor: "pointer",
//                 }}
//                 onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//                 onBlur={(e) => (e.target.style.borderColor = getBorderColor())}
//               >
//                 <option value="">Select Semester</option>
//                 {semesters.map((sem) => (
//                   <option key={sem} value={sem}>
//                     Semester {sem}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </motion.div>

//           {/* Scheme Dropdown */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaCalendarAlt
//                 style={{ marginRight: "0.5rem", color: "#8b5cf6" }}
//               />
//               Scheme
//             </label>
//             <select
//               name="scheme"
//               value={formData.scheme}
//               onChange={handleChange}
//               required
//               style={{
//                 width: "100%",
//                 padding: "0.9rem 1rem",
//                 border: `2px solid ${getBorderColor()}`,
//                 borderRadius: "16px",
//                 outline: "none",
//                 fontSize: "1rem",
//                 backgroundColor: getInputBackground(),
//                 color: getTextColor(),
//                 cursor: "pointer",
//               }}
//               onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//               onBlur={(e) => (e.target.style.borderColor = getBorderColor())}
//             >
//               <option value="">Select Scheme</option>
//               {schemes.map((scheme) => (
//                 <option key={scheme} value={scheme}>
//                   {scheme === "2022" ? "CBCS 2022 Scheme" : "CBCS 2025 Scheme"}
//                 </option>
//               ))}
//             </select>
//           </motion.div>

//           {/* Verification Notice */}
//           <motion.div
//             variants={itemVariants}
//             style={{
//               marginTop: "1rem",
//               padding: "1rem",
//               background: isDarkMode
//                 ? "rgba(139,92,246,0.1)"
//                 : "rgba(139,92,246,0.05)",
//               borderRadius: "16px",
//               border: `1px solid ${getBorderColor()}`,
//             }}
//           >
//             <div
//               style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
//             >
//               <div
//                 style={{
//                   width: "24px",
//                   height: "24px",
//                   background: "rgba(16,185,129,0.1)",
//                   borderRadius: "8px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <FaCheckCircle color="#10b981" size={12} />
//               </div>
//               <p
//                 style={{
//                   color: getTextSecondary(),
//                   fontSize: "0.75rem",
//                   margin: 0,
//                 }}
//               >
//                 After registration, you'll receive a verification email. Please
//                 check your inbox.
//               </p>
//             </div>
//           </motion.div>

//           {/* Submit Button */}
//           <motion.button
//             variants={itemVariants}
//             type="submit"
//             disabled={loading}
//             whileHover={{ scale: loading ? 1 : 1.02 }}
//             whileTap={{ scale: loading ? 1 : 0.98 }}
//             style={{
//               width: "100%",
//               padding: "1rem",
//               marginTop: "2rem",
//               background: loading
//                 ? "#94a3b8"
//                 : "linear-gradient(135deg, #8b5cf6, #3b82f6)",
//               color: "white",
//               border: "none",
//               borderRadius: "16px",
//               fontSize: "1rem",
//               fontWeight: 600,
//               cursor: loading ? "not-allowed" : "pointer",
//               transition: "all 0.3s",
//               boxShadow: loading ? "none" : "0 4px 14px 0 rgba(139,92,246,0.4)",
//             }}
//           >
//             {loading ? "Creating Account..." : "Create Account"}
//           </motion.button>
//         </form>

//         {/* Divider */}
//         <motion.div
//           variants={itemVariants}
//           style={{
//             margin: "1.5rem 0",
//             position: "relative",
//             textAlign: "center",
//           }}
//         >
//           <div
//             style={{
//               position: "absolute",
//               top: "50%",
//               left: 0,
//               right: 0,
//               height: "1px",
//               background: getBorderColor(),
//             }}
//           />
//           <span
//             style={{
//               background: getCardBackground(),
//               padding: "0 1rem",
//               position: "relative",
//               color: getTextSecondary(),
//               fontSize: "0.8rem",
//             }}
//           >
//             OR SIGN UP WITH
//           </span>
//         </motion.div>

//         {/* Social Signup Buttons */}
//         <motion.div
//           variants={itemVariants}
//           style={{
//             display: "grid",
//             gridTemplateColumns: "1fr 1fr",
//             gap: "1rem",
//             marginBottom: "1.5rem",
//           }}
//         >
//           <motion.button
//             whileHover={{ scale: 1.02 }}
//             whileTap={{ scale: 0.98 }}
//             style={{
//               padding: "0.75rem",
//               background: isDarkMode ? "rgba(255,255,255,0.05)" : "#f1f5f9",
//               border: `1px solid ${getBorderColor()}`,
//               borderRadius: "12px",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "0.5rem",
//               color: getTextSecondary(),
//               fontWeight: 500,
//               transition: "all 0.3s",
//             }}
//           >
//             <FaGoogle /> Google
//           </motion.button>
//           <motion.button
//             whileHover={{ scale: 1.02 }}
//             whileTap={{ scale: 0.98 }}
//             style={{
//               padding: "0.75rem",
//               background: isDarkMode ? "rgba(255,255,255,0.05)" : "#f1f5f9",
//               border: `1px solid ${getBorderColor()}`,
//               borderRadius: "12px",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "0.5rem",
//               color: getTextSecondary(),
//               fontWeight: 500,
//               transition: "all 0.3s",
//             }}
//           >
//             <FaGithub /> GitHub
//           </motion.button>
//         </motion.div>

//         {/* Login Link */}
//         <motion.div variants={itemVariants} style={{ textAlign: "center" }}>
//           <p style={{ color: getTextSecondary(), fontSize: "0.875rem" }}>
//             Already have an account?{" "}
//             <Link
//               to="/login"
//               style={{
//                 color: "#8b5cf6",
//                 textDecoration: "none",
//                 fontWeight: 600,
//                 transition: "color 0.3s",
//               }}
//               onMouseEnter={(e) => (e.target.style.color = "#3b82f6")}
//               onMouseLeave={(e) => (e.target.style.color = "#8b5cf6")}
//             >
//               Login here
//               <FaArrowRight
//                 style={{
//                   marginLeft: "0.3rem",
//                   fontSize: "0.7rem",
//                   display: "inline",
//                 }}
//               />
//             </Link>
//           </p>
//         </motion.div>

//         {/* Security Badge */}
//         <motion.div
//           variants={itemVariants}
//           style={{
//             marginTop: "1.5rem",
//             paddingTop: "1rem",
//             borderTop: `1px solid ${getBorderColor()}`,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "0.5rem",
//             flexWrap: "wrap",
//           }}
//         >
//           <FaShieldAlt size={12} color="#10b981" />
//           <span style={{ color: getTextSecondary(), fontSize: "0.7rem" }}>
//             Your data is protected with 256-bit encryption
//           </span>
//           <FaStar size={10} color="#f59e0b" />
//         </motion.div>
//       </motion.div>

//       <style>
//         {`
//           @keyframes spin {
//             from { transform: rotate(0deg); }
//             to { transform: rotate(360deg); }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default Register;

// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   FaUser,
//   FaEnvelope,
//   FaLock,
//   FaGraduationCap,
//   FaIdCard,
//   FaCalendarAlt,
//   FaArrowRight,
//   FaGoogle,
//   FaGithub,
//   FaShieldAlt,
//   FaCheckCircle,
//   FaEye,
//   FaEyeSlash,
//   FaExclamationTriangle,
//   FaRocket,
//   FaStar,
//   FaAward,
// } from "react-icons/fa";
// import { HiOutlineSparkles } from "react-icons/hi";
// import { useDispatch } from "react-redux";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { setUser } from "../store/slices/authSlice";
// import { useFooter } from "../context/FooterContext";

// const Register = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { setShowFooter } = useFooter();
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     password: "",
//     usn: "",
//     branch: "",
//     semester: "",
//     scheme: "2022",
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [isDarkMode, setIsDarkMode] = useState(false);
//   const [passwordStrength, setPasswordStrength] = useState(0);
//   const [isMobile, setIsMobile] = useState(false);
//   const [usnError, setUsnError] = useState("");
//   const [showUsnWarning, setShowUsnWarning] = useState(false);

//   const branches = ["CSE", "ISE", "ECE", "EEE", "MECH", "CIVIL", "AIML", "DS"];
//   const semesters = [1, 2, 3, 4, 5, 6, 7, 8];
//   const schemes = ["2022", "2025"];

//   // Hide footer
//   useEffect(() => {
//     setShowFooter(false);
//     return () => setShowFooter(true);
//   }, [setShowFooter]);

//   // Check dark mode
//   useEffect(() => {
//     const checkDarkMode = () => {
//       const dark =
//         document.documentElement.getAttribute("data-theme") === "dark";
//       setIsDarkMode(dark);
//     };
//     checkDarkMode();
//     const observer = new MutationObserver(checkDarkMode);
//     observer.observe(document.documentElement, {
//       attributes: true,
//       attributeFilter: ["data-theme"],
//     });
//     return () => observer.disconnect();
//   }, []);

//   // Check mobile
//   useEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth <= 768);
//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   // Check password strength
//   useEffect(() => {
//     const password = formData.password;
//     let strength = 0;
//     if (password.length >= 6) strength++;
//     if (password.length >= 8) strength++;
//     if (/[A-Z]/.test(password)) strength++;
//     if (/[0-9]/.test(password)) strength++;
//     if (/[^A-Za-z0-9]/.test(password)) strength++;
//     setPasswordStrength(Math.min(strength, 4));
//   }, [formData.password]);

//   // Validate USN
//   const validateUSN = (usn) => {
//     const usnPattern = /^[0-9]{1}[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{3}$/;
//     if (usn && !usnPattern.test(usn.toUpperCase())) {
//       setUsnError(
//         "Invalid USN format! Format: 1BM21CS001 (1 letter + 2 letters + 2 digits + 2 letters + 3 digits)",
//       );
//       setShowUsnWarning(true);
//       return false;
//     } else {
//       setUsnError("");
//       setShowUsnWarning(false);
//       return true;
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//     if (error) setError("");

//     if (name === "usn") {
//       validateUSN(value);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate USN before submission
//     if (!validateUSN(formData.usn)) {
//       toast.error("Please enter a valid USN format");
//       return;
//     }

//     setLoading(true);
//     setError("");

//     try {
//       const response = await axios.post(
//         "http://localhost:5001/api/auth/register",
//         formData,
//       );

//       if (response.data.requiresVerification) {
//         toast.success(response.data.message);
//         navigate("/login");
//       } else {
//         localStorage.setItem("token", response.data.token);
//         const userData = {
//           ...response.data.user,
//           _id: response.data.user.id || response.data.user._id,
//         };
//         dispatch(setUser(userData));
//         toast.success("Registration successful!");
//         navigate("/dashboard");
//       }
//     } catch (error) {
//       console.error("Registration error:", error);

//       if (error.response?.data?.errors) {
//         const errorMsg =
//           error.response.data.errors[0]?.msg || "Registration failed";
//         setError(errorMsg);
//         toast.error(errorMsg);
//       } else if (error.response?.data?.message) {
//         setError(error.response.data.message);
//         toast.error(error.response.data.message);
//       } else {
//         setError("Registration failed. Please try again.");
//         toast.error("Registration failed");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getPasswordStrengthColor = () => {
//     if (passwordStrength === 0) return "#ef4444";
//     if (passwordStrength === 1) return "#f59e0b";
//     if (passwordStrength === 2) return "#f59e0b";
//     if (passwordStrength === 3) return "#10b981";
//     return "#10b981";
//   };

//   const getPasswordStrengthText = () => {
//     if (passwordStrength === 0) return "Very Weak";
//     if (passwordStrength === 1) return "Weak";
//     if (passwordStrength === 2) return "Fair";
//     if (passwordStrength === 3) return "Good";
//     return "Strong";
//   };

//   // Helper functions for styling
//   const getTextColor = () => (isDarkMode ? "#f1f5f9" : "#1e293b");
//   const getTextSecondary = () => (isDarkMode ? "#94a3b8" : "#64748b");
//   const getBorderColor = () =>
//     isDarkMode ? "rgba(139,92,246,0.2)" : "rgba(139,92,246,0.1)";
//   const getCardBackground = () =>
//     isDarkMode ? "rgba(30, 30, 45, 0.9)" : "rgba(255, 255, 255, 0.95)";
//   const getInputBackground = () => (isDarkMode ? "rgba(0,0,0,0.3)" : "#ffffff");

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.05,
//         delayChildren: 0.2,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 20, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: { type: "spring", stiffness: 300, damping: 24 },
//     },
//   };

//   return (
//     <div
//       style={{
//         minHeight: "calc(100vh - 200px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: isMobile ? "1rem" : "2rem",
//         background: isDarkMode ? "#0a0a0f" : "#f5f7fb",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* Animated Background Grid */}
//       <div
//         style={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           pointerEvents: "none",
//           zIndex: 0,
//           backgroundImage: `radial-gradient(circle at 1px 1px, ${isDarkMode ? "rgba(139,92,246,0.1)" : "rgba(139,92,246,0.08)"} 1px, transparent 1px)`,
//           backgroundSize: "40px 40px",
//         }}
//       />

//       {/* Floating Gradient Orbs */}
//       <motion.div
//         animate={{ x: [0, 100, 0], y: [0, 50, 0] }}
//         transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
//         style={{
//           position: "fixed",
//           top: "10%",
//           left: "-5%",
//           width: "250px",
//           height: "250px",
//           background:
//             "radial-gradient(circle, rgba(139,92,246,0.3) 0%, transparent 70%)",
//           borderRadius: "50%",
//           filter: "blur(60px)",
//           pointerEvents: "none",
//           zIndex: 0,
//         }}
//       />
//       <motion.div
//         animate={{ x: [0, -100, 0], y: [0, 80, 0] }}
//         transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
//         style={{
//           position: "fixed",
//           bottom: "10%",
//           right: "-5%",
//           width: "300px",
//           height: "300px",
//           background:
//             "radial-gradient(circle, rgba(59,130,246,0.3) 0%, transparent 70%)",
//           borderRadius: "50%",
//           filter: "blur(60px)",
//           pointerEvents: "none",
//           zIndex: 0,
//         }}
//       />

//       <motion.div
//         variants={containerVariants}
//         initial="hidden"
//         animate="visible"
//         style={{
//           maxWidth: "560px",
//           width: "100%",
//           background: getCardBackground(),
//           backdropFilter: "blur(20px)",
//           borderRadius: "32px",
//           padding: isMobile ? "1.5rem" : "2.5rem",
//           boxShadow: isDarkMode
//             ? "0 25px 50px -12px rgba(0,0,0,0.5)"
//             : "0 25px 50px -12px rgba(0,0,0,0.25)",
//           border: `1px solid ${getBorderColor()}`,
//           position: "relative",
//           zIndex: 1,
//           maxHeight: "90vh",
//           overflowY: "auto",
//         }}
//       >
//         {/* Custom scrollbar styles */}
//         <style>
//           {`
//             .custom-scroll::-webkit-scrollbar {
//               width: 6px;
//             }
//             .custom-scroll::-webkit-scrollbar-track {
//               background: ${isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"};
//               border-radius: 10px;
//             }
//             .custom-scroll::-webkit-scrollbar-thumb {
//               background: linear-gradient(135deg, #8b5cf6, #3b82f6);
//               border-radius: 10px;
//             }
//           `}
//         </style>

//         {/* Animated gradient border top */}
//         <motion.div
//           animate={{
//             background: [
//               "linear-gradient(90deg, #8b5cf6, #3b82f6, #06b6d4, #8b5cf6)",
//               "linear-gradient(90deg, #3b82f6, #06b6d4, #8b5cf6, #3b82f6)",
//             ],
//           }}
//           transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             height: "4px",
//             borderRadius: "32px 32px 0 0",
//           }}
//         />

//         {/* Header with Illustration */}
//         <motion.div
//           variants={itemVariants}
//           style={{ textAlign: "center", marginBottom: "2rem" }}
//         >
//           <motion.div
//             animate={{ y: [0, -10, 0] }}
//             transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               justifyContent: "center",
//               marginBottom: "1rem",
//             }}
//           >
//             <div
//               style={{
//                 background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
//                 width: "70px",
//                 height: "70px",
//                 borderRadius: "24px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 boxShadow: "0 20px 40px -12px rgba(139,92,246,0.4)",
//               }}
//             >
//               <FaRocket size={32} color="white" />
//             </div>
//           </motion.div>
//           <h1
//             style={{
//               fontSize: isMobile ? "1.8rem" : "2rem",
//               marginBottom: "0.5rem",
//               background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
//               WebkitBackgroundClip: "text",
//               WebkitTextFillColor: "transparent",
//               fontWeight: 700,
//             }}
//           >
//             Join VTUGenX
//           </h1>
//           <p style={{ color: getTextSecondary() }}>
//             Create your account and start learning
//           </p>
//         </motion.div>

//         {/* Error Message Display */}
//         <AnimatePresence>
//           {error && (
//             <motion.div
//               initial={{ opacity: 0, y: -10 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -10 }}
//               style={{
//                 background: "rgba(239, 68, 68, 0.1)",
//                 color: "#ef4444",
//                 padding: "0.8rem 1rem",
//                 borderRadius: "16px",
//                 marginBottom: "1.5rem",
//                 fontSize: "0.85rem",
//                 textAlign: "center",
//                 border: "1px solid rgba(239, 68, 68, 0.3)",
//               }}
//             >
//               {error}
//             </motion.div>
//           )}
//         </AnimatePresence>

//         <form onSubmit={handleSubmit} className="custom-scroll">
//           {/* Full Name */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaUser style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
//               Full Name
//             </label>
//             <input
//               type="text"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               required
//               placeholder="Enter your full name"
//               style={{
//                 width: "100%",
//                 padding: "0.9rem 1rem",
//                 border: `2px solid ${error ? "#ef4444" : getBorderColor()}`,
//                 borderRadius: "16px",
//                 outline: "none",
//                 fontSize: "1rem",
//                 transition: "all 0.3s",
//                 backgroundColor: getInputBackground(),
//                 color: getTextColor(),
//               }}
//               onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//               onBlur={(e) => {
//                 if (!error) {
//                   e.target.style.borderColor = getBorderColor();
//                 }
//               }}
//             />
//           </motion.div>

//           {/* Email */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaEnvelope style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
//               Email Address
//             </label>
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               required
//               placeholder="Enter your email"
//               style={{
//                 width: "100%",
//                 padding: "0.9rem 1rem",
//                 border: `2px solid ${error ? "#ef4444" : getBorderColor()}`,
//                 borderRadius: "16px",
//                 outline: "none",
//                 fontSize: "1rem",
//                 transition: "all 0.3s",
//                 backgroundColor: getInputBackground(),
//                 color: getTextColor(),
//               }}
//               onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//               onBlur={(e) => {
//                 if (!error) {
//                   e.target.style.borderColor = getBorderColor();
//                 }
//               }}
//             />
//           </motion.div>

//           {/* Password */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaLock style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
//               Password
//             </label>
//             <div style={{ position: "relative" }}>
//               <input
//                 type={showPassword ? "text" : "password"}
//                 name="password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 placeholder="Create a password (min. 6 characters)"
//                 style={{
//                   width: "100%",
//                   padding: "0.9rem 1rem",
//                   paddingRight: "3rem",
//                   border: `2px solid ${error ? "#ef4444" : getBorderColor()}`,
//                   borderRadius: "16px",
//                   outline: "none",
//                   fontSize: "1rem",
//                   transition: "all 0.3s",
//                   backgroundColor: getInputBackground(),
//                   color: getTextColor(),
//                 }}
//                 onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//                 onBlur={(e) => {
//                   if (!error) {
//                     e.target.style.borderColor = getBorderColor();
//                   }
//                 }}
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowPassword(!showPassword)}
//                 style={{
//                   position: "absolute",
//                   right: "12px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   background: "none",
//                   border: "none",
//                   cursor: "pointer",
//                   color: getTextSecondary(),
//                 }}
//               >
//                 {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
//               </button>
//             </div>

//             {/* Password Strength Indicator */}
//             {formData.password && (
//               <motion.div
//                 initial={{ opacity: 0, height: 0 }}
//                 animate={{ opacity: 1, height: "auto" }}
//                 style={{ marginTop: "0.5rem" }}
//               >
//                 <div
//                   style={{
//                     height: "4px",
//                     background: isDarkMode
//                       ? "rgba(255,255,255,0.1)"
//                       : "#e2e8f0",
//                     borderRadius: "2px",
//                     overflow: "hidden",
//                   }}
//                 >
//                   <motion.div
//                     initial={{ width: 0 }}
//                     animate={{ width: `${(passwordStrength / 4) * 100}%` }}
//                     transition={{ duration: 0.3 }}
//                     style={{
//                       height: "100%",
//                       background: getPasswordStrengthColor(),
//                     }}
//                   />
//                 </div>
//                 <p
//                   style={{
//                     fontSize: "0.7rem",
//                     color: getPasswordStrengthColor(),
//                     marginTop: "0.25rem",
//                   }}
//                 >
//                   Password strength: {getPasswordStrengthText()}
//                 </p>
//               </motion.div>
//             )}
//           </motion.div>

//           {/* USN with Warning */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaIdCard style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
//               USN (University Seat Number)
//             </label>
//             <div style={{ position: "relative" }}>
//               <input
//                 type="text"
//                 name="usn"
//                 value={formData.usn}
//                 onChange={handleChange}
//                 required
//                 placeholder="e.g., 1BM21CS001"
//                 style={{
//                   width: "100%",
//                   padding: "0.9rem 1rem",
//                   border: `2px solid ${usnError ? "#ef4444" : error ? "#ef4444" : getBorderColor()}`,
//                   borderRadius: "16px",
//                   outline: "none",
//                   fontSize: "1rem",
//                   transition: "all 0.3s",
//                   backgroundColor: getInputBackground(),
//                   color: getTextColor(),
//                   textTransform: "uppercase",
//                 }}
//                 onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//                 onBlur={(e) => {
//                   if (!usnError && !error) {
//                     e.target.style.borderColor = getBorderColor();
//                   }
//                 }}
//               />
//               {usnError && (
//                 <div
//                   style={{
//                     position: "absolute",
//                     right: "12px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#ef4444",
//                   }}
//                 >
//                   <FaExclamationTriangle size={16} />
//                 </div>
//               )}
//             </div>

//             {/* USN Warning Message */}
//             <AnimatePresence>
//               {showUsnWarning && usnError && (
//                 <motion.div
//                   initial={{ opacity: 0, y: -10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   exit={{ opacity: 0, y: -10 }}
//                   style={{
//                     marginTop: "0.5rem",
//                     padding: "0.5rem 0.75rem",
//                     background: "rgba(239, 68, 68, 0.1)",
//                     borderRadius: "12px",
//                     borderLeft: "3px solid #ef4444",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.5rem",
//                     }}
//                   >
//                     <FaExclamationTriangle size={12} color="#ef4444" />
//                     <span style={{ fontSize: "0.7rem", color: "#ef4444" }}>
//                       {usnError}
//                     </span>
//                   </div>
//                   <p
//                     style={{
//                       fontSize: "0.65rem",
//                       color: getTextSecondary(),
//                       marginTop: "0.3rem",
//                       marginLeft: "1.2rem",
//                     }}
//                   >
//                     Example: 1BM21CS001 (1 digit + 2 letters + 2 digits + 2
//                     letters + 3 digits)
//                   </p>
//                 </motion.div>
//               )}
//             </AnimatePresence>

//             {/* Info note about USN */}
//             <p
//               style={{
//                 fontSize: "0.65rem",
//                 color: getTextSecondary(),
//                 marginTop: "0.3rem",
//               }}
//             >
//               <FaExclamationTriangle
//                 size={10}
//                 style={{ marginRight: "0.3rem", color: "#f59e0b" }}
//               />{" "}
//               Enter your USN carefully. You cannot modify it later.
//             </p>
//           </motion.div>

//           {/* Branch and Semester */}
//           <motion.div
//             variants={itemVariants}
//             style={{
//               display: "grid",
//               gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
//               gap: "1rem",
//               marginBottom: "1.5rem",
//             }}
//           >
//             <div>
//               <label
//                 style={{
//                   display: "block",
//                   marginBottom: "0.5rem",
//                   color: getTextSecondary(),
//                   fontWeight: 500,
//                   fontSize: "0.875rem",
//                 }}
//               >
//                 <FaGraduationCap
//                   style={{ marginRight: "0.5rem", color: "#8b5cf6" }}
//                 />
//                 Branch
//               </label>
//               <select
//                 name="branch"
//                 value={formData.branch}
//                 onChange={handleChange}
//                 required
//                 style={{
//                   width: "100%",
//                   padding: "0.9rem 1rem",
//                   border: `2px solid ${getBorderColor()}`,
//                   borderRadius: "16px",
//                   outline: "none",
//                   fontSize: "1rem",
//                   backgroundColor: getInputBackground(),
//                   color: getTextColor(),
//                   cursor: "pointer",
//                 }}
//                 onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//                 onBlur={(e) => (e.target.style.borderColor = getBorderColor())}
//               >
//                 <option value="">Select Branch</option>
//                 {branches.map((branch) => (
//                   <option key={branch} value={branch}>
//                     {branch}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div>
//               <label
//                 style={{
//                   display: "block",
//                   marginBottom: "0.5rem",
//                   color: getTextSecondary(),
//                   fontWeight: 500,
//                   fontSize: "0.875rem",
//                 }}
//               >
//                 <FaGraduationCap
//                   style={{ marginRight: "0.5rem", color: "#8b5cf6" }}
//                 />
//                 Semester
//               </label>
//               <select
//                 name="semester"
//                 value={formData.semester}
//                 onChange={handleChange}
//                 required
//                 style={{
//                   width: "100%",
//                   padding: "0.9rem 1rem",
//                   border: `2px solid ${getBorderColor()}`,
//                   borderRadius: "16px",
//                   outline: "none",
//                   fontSize: "1rem",
//                   backgroundColor: getInputBackground(),
//                   color: getTextColor(),
//                   cursor: "pointer",
//                 }}
//                 onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//                 onBlur={(e) => (e.target.style.borderColor = getBorderColor())}
//               >
//                 <option value="">Select Semester</option>
//                 {semesters.map((sem) => (
//                   <option key={sem} value={sem}>
//                     Semester {sem}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </motion.div>

//           {/* Scheme Dropdown */}
//           <motion.div
//             variants={itemVariants}
//             style={{ marginBottom: "1.5rem" }}
//           >
//             <label
//               style={{
//                 display: "block",
//                 marginBottom: "0.5rem",
//                 color: getTextSecondary(),
//                 fontWeight: 500,
//                 fontSize: "0.875rem",
//               }}
//             >
//               <FaCalendarAlt
//                 style={{ marginRight: "0.5rem", color: "#8b5cf6" }}
//               />
//               Scheme
//             </label>
//             <select
//               name="scheme"
//               value={formData.scheme}
//               onChange={handleChange}
//               required
//               style={{
//                 width: "100%",
//                 padding: "0.9rem 1rem",
//                 border: `2px solid ${getBorderColor()}`,
//                 borderRadius: "16px",
//                 outline: "none",
//                 fontSize: "1rem",
//                 backgroundColor: getInputBackground(),
//                 color: getTextColor(),
//                 cursor: "pointer",
//               }}
//               onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
//               onBlur={(e) => (e.target.style.borderColor = getBorderColor())}
//             >
//               <option value="">Select Scheme</option>
//               {schemes.map((scheme) => (
//                 <option key={scheme} value={scheme}>
//                   {scheme === "2022" ? "CBCS 2022 Scheme" : "CBCS 2025 Scheme"}
//                 </option>
//               ))}
//             </select>
//           </motion.div>

//           {/* Verification Notice */}
//           <motion.div
//             variants={itemVariants}
//             style={{
//               marginTop: "1rem",
//               padding: "1rem",
//               background: isDarkMode
//                 ? "rgba(139,92,246,0.1)"
//                 : "rgba(139,92,246,0.05)",
//               borderRadius: "16px",
//               border: `1px solid ${getBorderColor()}`,
//             }}
//           >
//             <div
//               style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
//             >
//               <div
//                 style={{
//                   width: "24px",
//                   height: "24px",
//                   background: "rgba(16,185,129,0.1)",
//                   borderRadius: "8px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <FaCheckCircle color="#10b981" size={12} />
//               </div>
//               <p
//                 style={{
//                   color: getTextSecondary(),
//                   fontSize: "0.75rem",
//                   margin: 0,
//                 }}
//               >
//                 After registration, you'll receive a verification email. Please
//                 check your inbox.
//               </p>
//             </div>
//           </motion.div>

//           {/* Submit Button */}
//           <motion.button
//             variants={itemVariants}
//             type="submit"
//             disabled={loading}
//             whileHover={{ scale: loading ? 1 : 1.02 }}
//             whileTap={{ scale: loading ? 1 : 0.98 }}
//             style={{
//               width: "100%",
//               padding: "1rem",
//               marginTop: "2rem",
//               background: loading
//                 ? "#94a3b8"
//                 : "linear-gradient(135deg, #8b5cf6, #3b82f6)",
//               color: "white",
//               border: "none",
//               borderRadius: "16px",
//               fontSize: "1rem",
//               fontWeight: 600,
//               cursor: loading ? "not-allowed" : "pointer",
//               transition: "all 0.3s",
//               boxShadow: loading ? "none" : "0 4px 14px 0 rgba(139,92,246,0.4)",
//             }}
//           >
//             {loading ? "Creating Account..." : "Create Account"}
//           </motion.button>
//         </form>

//         {/* Divider */}
//         <motion.div
//           variants={itemVariants}
//           style={{
//             margin: "1.5rem 0",
//             position: "relative",
//             textAlign: "center",
//           }}
//         >
//           <div
//             style={{
//               position: "absolute",
//               top: "50%",
//               left: 0,
//               right: 0,
//               height: "1px",
//               background: getBorderColor(),
//             }}
//           />
//           <span
//             style={{
//               background: getCardBackground(),
//               padding: "0 1rem",
//               position: "relative",
//               color: getTextSecondary(),
//               fontSize: "0.8rem",
//             }}
//           >
//             OR SIGN UP WITH
//           </span>
//         </motion.div>

//         {/* Social Signup Buttons */}
//         <motion.div
//           variants={itemVariants}
//           style={{
//             display: "grid",
//             gridTemplateColumns: "1fr 1fr",
//             gap: "1rem",
//             marginBottom: "1.5rem",
//           }}
//         >
//           <motion.button
//             whileHover={{ scale: 1.02 }}
//             whileTap={{ scale: 0.98 }}
//             style={{
//               padding: "0.75rem",
//               background: isDarkMode ? "rgba(255,255,255,0.05)" : "#f1f5f9",
//               border: `1px solid ${getBorderColor()}`,
//               borderRadius: "12px",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "0.5rem",
//               color: getTextSecondary(),
//               fontWeight: 500,
//               transition: "all 0.3s",
//             }}
//           >
//             <FaGoogle /> Google
//           </motion.button>
//           <motion.button
//             whileHover={{ scale: 1.02 }}
//             whileTap={{ scale: 0.98 }}
//             style={{
//               padding: "0.75rem",
//               background: isDarkMode ? "rgba(255,255,255,0.05)" : "#f1f5f9",
//               border: `1px solid ${getBorderColor()}`,
//               borderRadius: "12px",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "0.5rem",
//               color: getTextSecondary(),
//               fontWeight: 500,
//               transition: "all 0.3s",
//             }}
//           >
//             <FaGithub /> GitHub
//           </motion.button>
//         </motion.div>

//         {/* Login Link */}
//         <motion.div variants={itemVariants} style={{ textAlign: "center" }}>
//           <p style={{ color: getTextSecondary(), fontSize: "0.875rem" }}>
//             Already have an account?{" "}
//             <Link
//               to="/login"
//               style={{
//                 color: "#8b5cf6",
//                 textDecoration: "none",
//                 fontWeight: 600,
//                 transition: "color 0.3s",
//               }}
//               onMouseEnter={(e) => (e.target.style.color = "#3b82f6")}
//               onMouseLeave={(e) => (e.target.style.color = "#8b5cf6")}
//             >
//               Login here
//               <FaArrowRight
//                 style={{
//                   marginLeft: "0.3rem",
//                   fontSize: "0.7rem",
//                   display: "inline",
//                 }}
//               />
//             </Link>
//           </p>
//         </motion.div>

//         {/* Security Badge */}
//         <motion.div
//           variants={itemVariants}
//           style={{
//             marginTop: "1.5rem",
//             paddingTop: "1rem",
//             borderTop: `1px solid ${getBorderColor()}`,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "0.5rem",
//             flexWrap: "wrap",
//           }}
//         >
//           <FaShieldAlt size={12} color="#10b981" />
//           <span style={{ color: getTextSecondary(), fontSize: "0.7rem" }}>
//             Your data is protected with 256-bit encryption
//           </span>
//           <FaStar size={10} color="#f59e0b" />
//         </motion.div>
//       </motion.div>

//       <style>
//         {`
//           @keyframes spin {
//             from { transform: rotate(0deg); }
//             to { transform: rotate(360deg); }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default Register;

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaUser,
  FaEnvelope,
  FaLock,
  FaGraduationCap,
  FaIdCard,
  FaCalendarAlt,
  FaArrowRight,
  FaGoogle,
  FaGithub,
  FaShieldAlt,
  FaCheckCircle,
  FaEye,
  FaEyeSlash,
  FaExclamationTriangle,
  FaRocket,
  FaStar,
  FaAward,
} from "react-icons/fa";
import { HiOutlineSparkles } from "react-icons/hi";
import { useDispatch } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import { setUser } from "../store/slices/authSlice";
import { useFooter } from "../context/FooterContext";

// ============================================
// API URL Configuration for VTUGenX
// Backend URLs:
// - Production (Custom Domain): https://vtugenx.in
// - Production (Render): https://vtugenx-backend.onrender.com
// - Local Development: http://localhost:5001
// ============================================
const getApiBaseUrl = () => {
  // First priority: Environment variable
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Get current hostname
  const hostname = window.location.hostname;

  // Local development
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:5001";
  }

  // Production - Use custom domain if available, otherwise fallback to Render URL
  // Since you have vtugenx.in pointing to your backend, use that
  return "https://vtugenx.in";
  // Fallback to Render URL if needed:
  // return 'https://vtugenx-backend.onrender.com';
};

// Create axios instance with proper base URL
const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
  withCredentials: true, // Important for cookies/sessions if needed
});

// Request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    // console.log(
    //   `🚀 API Request: ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`,
    // );
    // console.log("📦 Request data:", { ...config.data, password: "***" });
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor for debugging
api.interceptors.response.use(
  (response) => {
    // console.log(`✅ API Response: ${response.status} - ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error(
      `❌ API Error: ${error.response?.status} - ${error.config?.url}`,
    );
    console.error("Error details:", error.response?.data);
    return Promise.reject(error);
  },
);

const Register = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setShowFooter } = useFooter();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    usn: "",
    branch: "",
    semester: "",
    scheme: "2022",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [usnError, setUsnError] = useState("");
  const [showUsnWarning, setShowUsnWarning] = useState(false);

  const branches = ["CSE", "ISE", "ECE", "EEE", "MECH", "CIVIL", "AIML", "DS"];
  const semesters = [1, 2, 3, 4, 5, 6, 7, 8];
  const schemes = ["2022", "2025"];

  // Hide footer
  useEffect(() => {
    setShowFooter(false);
    return () => setShowFooter(true);
  }, [setShowFooter]);

  // Check dark mode
  useEffect(() => {
    const checkDarkMode = () => {
      const dark =
        document.documentElement.getAttribute("data-theme") === "dark";
      setIsDarkMode(dark);
    };
    checkDarkMode();
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });
    return () => observer.disconnect();
  }, []);

  // Check mobile
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Check password strength
  useEffect(() => {
    const password = formData.password;
    let strength = 0;
    if (password.length >= 6) strength++;
    if (password.length >= 8) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[^A-Za-z0-9]/.test(password)) strength++;
    setPasswordStrength(Math.min(strength, 4));
  }, [formData.password]);

  // Validate USN - FIXED PATTERN
  const validateUSN = (usn) => {
    const normalizedUsn = (usn || "").trim().toUpperCase();
    const usnPattern = /^[1-4][A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{3}$/;
    if (normalizedUsn && !usnPattern.test(normalizedUsn)) {
      setUsnError(
        "Invalid USN format! Use format like 1BM21CS001 or 3GN22CS024.",
      );
      setShowUsnWarning(true);
      return false;
    } else {
      setUsnError("");
      setShowUsnWarning(false);
      return true;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const normalizedValue = name === "usn" ? value.toUpperCase() : value;
    setFormData({
      ...formData,
      [name]: normalizedValue,
    });
    if (error) setError("");

    if (name === "usn") {
      validateUSN(normalizedValue);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate USN before submission
    if (!validateUSN(formData.usn)) {
      toast.error("Please enter a valid USN format");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const payload = {
        ...formData,
        usn: formData.usn.trim().toUpperCase(),
      };
      // // Log the request for debugging
      // console.log(" Sending registration request to:", api.defaults.baseURL);
      // console.log(" Request data:", { ...formData, password: "***" });

      const response = await api.post("/api/auth/register", payload);

      if (response.data.requiresVerification) {
        toast.success(response.data.message);
        navigate("/login");
      } else {
        localStorage.setItem("token", response.data.token);
        const userData = {
          ...response.data.user,
          _id: response.data.user.id || response.data.user._id,
        };
        dispatch(setUser(userData));
        toast.success("Registration successful!");
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Registration error:", error);
      console.error("Error details:", error.response?.data);

      // Better error handling for validation errors
      if (error.response?.data?.errors) {
        const errorMsgs = error.response.data.errors
          .map((err) => err.msg || err.message)
          .join(", ");
        setError(errorMsgs);
        toast.error(errorMsgs);
      } else if (error.response?.data?.message) {
        setError(error.response.data.message);
        toast.error(error.response.data.message);
      } else {
        setError("Registration failed. Please try again.");
        toast.error("Registration failed");
      }
    } finally {
      setLoading(false);
    }
  };

  const getPasswordStrengthColor = () => {
    if (passwordStrength === 0) return "#ef4444";
    if (passwordStrength === 1) return "#f59e0b";
    if (passwordStrength === 2) return "#f59e0b";
    if (passwordStrength === 3) return "#10b981";
    return "#10b981";
  };

  const getPasswordStrengthText = () => {
    if (passwordStrength === 0) return "Very Weak";
    if (passwordStrength === 1) return "Weak";
    if (passwordStrength === 2) return "Fair";
    if (passwordStrength === 3) return "Good";
    return "Strong";
  };

  // Helper functions for styling
  const getTextColor = () => (isDarkMode ? "#f1f5f9" : "#1e293b");
  const getTextSecondary = () => (isDarkMode ? "#94a3b8" : "#64748b");
  const getBorderColor = () =>
    isDarkMode ? "rgba(139,92,246,0.2)" : "rgba(139,92,246,0.1)";
  const getCardBackground = () =>
    isDarkMode ? "rgba(30, 30, 45, 0.9)" : "rgba(255, 255, 255, 0.95)";
  const getInputBackground = () => (isDarkMode ? "rgba(0,0,0,0.3)" : "#ffffff");

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 300, damping: 24 },
    },
  };

  return (
    <div
      style={{
        minHeight: "calc(100vh - 200px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "1rem" : "2rem",
        background: isDarkMode ? "#0a0a0f" : "#f5f7fb",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Animated Background Grid */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: "none",
          zIndex: 0,
          backgroundImage: `radial-gradient(circle at 1px 1px, ${isDarkMode ? "rgba(139,92,246,0.1)" : "rgba(139,92,246,0.08)"} 1px, transparent 1px)`,
          backgroundSize: "40px 40px",
        }}
      />

      {/* Floating Gradient Orbs */}
      <motion.div
        animate={{ x: [0, 100, 0], y: [0, 50, 0] }}
        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
        style={{
          position: "fixed",
          top: "10%",
          left: "-5%",
          width: "250px",
          height: "250px",
          background:
            "radial-gradient(circle, rgba(139,92,246,0.3) 0%, transparent 70%)",
          borderRadius: "50%",
          filter: "blur(60px)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />
      <motion.div
        animate={{ x: [0, -100, 0], y: [0, 80, 0] }}
        transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
        style={{
          position: "fixed",
          bottom: "10%",
          right: "-5%",
          width: "300px",
          height: "300px",
          background:
            "radial-gradient(circle, rgba(59,130,246,0.3) 0%, transparent 70%)",
          borderRadius: "50%",
          filter: "blur(60px)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        style={{
          maxWidth: "560px",
          width: "100%",
          background: getCardBackground(),
          backdropFilter: "blur(20px)",
          borderRadius: "32px",
          padding: isMobile ? "1.5rem" : "2.5rem",
          boxShadow: isDarkMode
            ? "0 25px 50px -12px rgba(0,0,0,0.5)"
            : "0 25px 50px -12px rgba(0,0,0,0.25)",
          border: `1px solid ${getBorderColor()}`,
          position: "relative",
          zIndex: 1,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        {/* Custom scrollbar styles */}
        <style>
          {`
            .custom-scroll::-webkit-scrollbar {
              width: 6px;
            }
            .custom-scroll::-webkit-scrollbar-track {
              background: ${isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"};
              border-radius: 10px;
            }
            .custom-scroll::-webkit-scrollbar-thumb {
              background: linear-gradient(135deg, #8b5cf6, #3b82f6);
              border-radius: 10px;
            }
          `}
        </style>

        {/* Animated gradient border top */}
        <motion.div
          animate={{
            background: [
              "linear-gradient(90deg, #8b5cf6, #3b82f6, #06b6d4, #8b5cf6)",
              "linear-gradient(90deg, #3b82f6, #06b6d4, #8b5cf6, #3b82f6)",
            ],
          }}
          transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "4px",
            borderRadius: "32px 32px 0 0",
          }}
        />

        {/* Header with Illustration */}
        <motion.div
          variants={itemVariants}
          style={{ textAlign: "center", marginBottom: "2rem" }}
        >
          <motion.div
            animate={{ y: [0, -10, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "1rem",
            }}
          >
            <div
              style={{
                background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
                width: "70px",
                height: "70px",
                borderRadius: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 20px 40px -12px rgba(139,92,246,0.4)",
              }}
            >
              <FaRocket size={32} color="white" />
            </div>
          </motion.div>
          <h1
            style={{
              fontSize: isMobile ? "1.8rem" : "2rem",
              marginBottom: "0.5rem",
              background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: 700,
            }}
          >
            Join VTUGenX
          </h1>
          <p style={{ color: getTextSecondary() }}>
            Create your account and start learning
          </p>
        </motion.div>

        {/* Error Message Display */}
        <AnimatePresence>
          {error && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              style={{
                background: "rgba(239, 68, 68, 0.1)",
                color: "#ef4444",
                padding: "0.8rem 1rem",
                borderRadius: "16px",
                marginBottom: "1.5rem",
                fontSize: "0.85rem",
                textAlign: "center",
                border: "1px solid rgba(239, 68, 68, 0.3)",
              }}
            >
              {error}
            </motion.div>
          )}
        </AnimatePresence>

        <form onSubmit={handleSubmit} className="custom-scroll">
          {/* Full Name */}
          <motion.div
            variants={itemVariants}
            style={{ marginBottom: "1.5rem" }}
          >
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                color: getTextSecondary(),
                fontWeight: 500,
                fontSize: "0.875rem",
              }}
            >
              <FaUser style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
              Full Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your full name"
              style={{
                width: "100%",
                padding: "0.9rem 1rem",
                border: `2px solid ${error ? "#ef4444" : getBorderColor()}`,
                borderRadius: "16px",
                outline: "none",
                fontSize: "1rem",
                transition: "all 0.3s",
                backgroundColor: getInputBackground(),
                color: getTextColor(),
              }}
              onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
              onBlur={(e) => {
                if (!error) {
                  e.target.style.borderColor = getBorderColor();
                }
              }}
            />
          </motion.div>

          {/* Email */}
          <motion.div
            variants={itemVariants}
            style={{ marginBottom: "1.5rem" }}
          >
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                color: getTextSecondary(),
                fontWeight: 500,
                fontSize: "0.875rem",
              }}
            >
              <FaEnvelope style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
              style={{
                width: "100%",
                padding: "0.9rem 1rem",
                border: `2px solid ${error ? "#ef4444" : getBorderColor()}`,
                borderRadius: "16px",
                outline: "none",
                fontSize: "1rem",
                transition: "all 0.3s",
                backgroundColor: getInputBackground(),
                color: getTextColor(),
              }}
              onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
              onBlur={(e) => {
                if (!error) {
                  e.target.style.borderColor = getBorderColor();
                }
              }}
            />
          </motion.div>

          {/* Password */}
          <motion.div
            variants={itemVariants}
            style={{ marginBottom: "1.5rem" }}
          >
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                color: getTextSecondary(),
                fontWeight: 500,
                fontSize: "0.875rem",
              }}
            >
              <FaLock style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
              Password
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="Create a password (min. 6 characters)"
                style={{
                  width: "100%",
                  padding: "0.9rem 1rem",
                  paddingRight: "3rem",
                  border: `2px solid ${error ? "#ef4444" : getBorderColor()}`,
                  borderRadius: "16px",
                  outline: "none",
                  fontSize: "1rem",
                  transition: "all 0.3s",
                  backgroundColor: getInputBackground(),
                  color: getTextColor(),
                }}
                onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
                onBlur={(e) => {
                  if (!error) {
                    e.target.style.borderColor = getBorderColor();
                  }
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: getTextSecondary(),
                }}
              >
                {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
              </button>
            </div>

            {/* Password Strength Indicator */}
            {formData.password && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                style={{ marginTop: "0.5rem" }}
              >
                <div
                  style={{
                    height: "4px",
                    background: isDarkMode
                      ? "rgba(255,255,255,0.1)"
                      : "#e2e8f0",
                    borderRadius: "2px",
                    overflow: "hidden",
                  }}
                >
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${(passwordStrength / 4) * 100}%` }}
                    transition={{ duration: 0.3 }}
                    style={{
                      height: "100%",
                      background: getPasswordStrengthColor(),
                    }}
                  />
                </div>
                <p
                  style={{
                    fontSize: "0.7rem",
                    color: getPasswordStrengthColor(),
                    marginTop: "0.25rem",
                  }}
                >
                  Password strength: {getPasswordStrengthText()}
                </p>
              </motion.div>
            )}
          </motion.div>

          {/* USN with Warning */}
          <motion.div
            variants={itemVariants}
            style={{ marginBottom: "1.5rem" }}
          >
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                color: getTextSecondary(),
                fontWeight: 500,
                fontSize: "0.875rem",
              }}
            >
              <FaIdCard style={{ marginRight: "0.5rem", color: "#8b5cf6" }} />
              USN (University Seat Number)
            </label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                name="usn"
                value={formData.usn}
                onChange={handleChange}
                required
                placeholder="e.g., 1BM21CS001"
                style={{
                  width: "100%",
                  padding: "0.9rem 1rem",
                  border: `2px solid ${usnError ? "#ef4444" : error ? "#ef4444" : getBorderColor()}`,
                  borderRadius: "16px",
                  outline: "none",
                  fontSize: "1rem",
                  transition: "all 0.3s",
                  backgroundColor: getInputBackground(),
                  color: getTextColor(),
                  textTransform: "uppercase",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
                onBlur={(e) => {
                  if (!usnError && !error) {
                    e.target.style.borderColor = getBorderColor();
                  }
                }}
              />
              {usnError && (
                <div
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#ef4444",
                  }}
                >
                  <FaExclamationTriangle size={16} />
                </div>
              )}
            </div>

            {/* USN Warning Message */}
            <AnimatePresence>
              {showUsnWarning && usnError && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  style={{
                    marginTop: "0.5rem",
                    padding: "0.5rem 0.75rem",
                    background: "rgba(239, 68, 68, 0.1)",
                    borderRadius: "12px",
                    borderLeft: "3px solid #ef4444",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <FaExclamationTriangle size={12} color="#ef4444" />
                    <span style={{ fontSize: "0.7rem", color: "#ef4444" }}>
                      {usnError}
                    </span>
                  </div>
                  <p
                    style={{
                      fontSize: "0.65rem",
                      color: getTextSecondary(),
                      marginTop: "0.3rem",
                      marginLeft: "1.2rem",
                    }}
                  >
                    Example: 1BM21CS001 (1 digit + 2 letters + 2 digits + 2
                    letters + 3 digits)
                  </p>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Info note about USN */}
            <p
              style={{
                fontSize: "0.65rem",
                color: getTextSecondary(),
                marginTop: "0.3rem",
              }}
            >
              <FaExclamationTriangle
                size={10}
                style={{ marginRight: "0.3rem", color: "#f59e0b" }}
              />{" "}
              Enter your USN carefully. You cannot modify it later.
            </p>
          </motion.div>

          {/* Branch and Semester */}
          <motion.div
            variants={itemVariants}
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
              gap: "1rem",
              marginBottom: "1.5rem",
            }}
          >
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "0.5rem",
                  color: getTextSecondary(),
                  fontWeight: 500,
                  fontSize: "0.875rem",
                }}
              >
                <FaGraduationCap
                  style={{ marginRight: "0.5rem", color: "#8b5cf6" }}
                />
                Branch
              </label>
              <select
                name="branch"
                value={formData.branch}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "0.9rem 1rem",
                  border: `2px solid ${getBorderColor()}`,
                  borderRadius: "16px",
                  outline: "none",
                  fontSize: "1rem",
                  backgroundColor: getInputBackground(),
                  color: getTextColor(),
                  cursor: "pointer",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
                onBlur={(e) => (e.target.style.borderColor = getBorderColor())}
              >
                <option value="">Select Branch</option>
                {branches.map((branch) => (
                  <option key={branch} value={branch}>
                    {branch}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "0.5rem",
                  color: getTextSecondary(),
                  fontWeight: 500,
                  fontSize: "0.875rem",
                }}
              >
                <FaGraduationCap
                  style={{ marginRight: "0.5rem", color: "#8b5cf6" }}
                />
                Semester
              </label>
              <select
                name="semester"
                value={formData.semester}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "0.9rem 1rem",
                  border: `2px solid ${getBorderColor()}`,
                  borderRadius: "16px",
                  outline: "none",
                  fontSize: "1rem",
                  backgroundColor: getInputBackground(),
                  color: getTextColor(),
                  cursor: "pointer",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
                onBlur={(e) => (e.target.style.borderColor = getBorderColor())}
              >
                <option value="">Select Semester</option>
                {semesters.map((sem) => (
                  <option key={sem} value={sem}>
                    Semester {sem}
                  </option>
                ))}
              </select>
            </div>
          </motion.div>

          {/* Scheme Dropdown */}
          <motion.div
            variants={itemVariants}
            style={{ marginBottom: "1.5rem" }}
          >
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                color: getTextSecondary(),
                fontWeight: 500,
                fontSize: "0.875rem",
              }}
            >
              <FaCalendarAlt
                style={{ marginRight: "0.5rem", color: "#8b5cf6" }}
              />
              Scheme
            </label>
            <select
              name="scheme"
              value={formData.scheme}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "0.9rem 1rem",
                border: `2px solid ${getBorderColor()}`,
                borderRadius: "16px",
                outline: "none",
                fontSize: "1rem",
                backgroundColor: getInputBackground(),
                color: getTextColor(),
                cursor: "pointer",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#8b5cf6")}
              onBlur={(e) => (e.target.style.borderColor = getBorderColor())}
            >
              <option value="">Select Scheme</option>
              {schemes.map((scheme) => (
                <option key={scheme} value={scheme}>
                  {scheme === "2022" ? "CBCS 2022 Scheme" : "CBCS 2025 Scheme"}
                </option>
              ))}
            </select>
          </motion.div>

          {/* Verification Notice */}
          <motion.div
            variants={itemVariants}
            style={{
              marginTop: "1rem",
              padding: "1rem",
              background: isDarkMode
                ? "rgba(139,92,246,0.1)"
                : "rgba(139,92,246,0.05)",
              borderRadius: "16px",
              border: `1px solid ${getBorderColor()}`,
            }}
          >
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  background: "rgba(16,185,129,0.1)",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FaCheckCircle color="#10b981" size={12} />
              </div>
              <p
                style={{
                  color: getTextSecondary(),
                  fontSize: "0.75rem",
                  margin: 0,
                }}
              >
                After registration, you'll receive a verification email. Please
                check your inbox.
              </p>
            </div>
          </motion.div>

          {/* Submit Button */}
          <motion.button
            variants={itemVariants}
            type="submit"
            disabled={loading}
            whileHover={{ scale: loading ? 1 : 1.02 }}
            whileTap={{ scale: loading ? 1 : 0.98 }}
            style={{
              width: "100%",
              padding: "1rem",
              marginTop: "2rem",
              background: loading
                ? "#94a3b8"
                : "linear-gradient(135deg, #8b5cf6, #3b82f6)",
              color: "white",
              border: "none",
              borderRadius: "16px",
              fontSize: "1rem",
              fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
              transition: "all 0.3s",
              boxShadow: loading ? "none" : "0 4px 14px 0 rgba(139,92,246,0.4)",
            }}
          >
            {loading ? "Creating Account..." : "Create Account"}
          </motion.button>
        </form>

        {/* Divider */}
        <motion.div
          variants={itemVariants}
          style={{
            margin: "1.5rem 0",
            position: "relative",
            textAlign: "center",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: 0,
              right: 0,
              height: "1px",
              background: getBorderColor(),
            }}
          />
        </motion.div>

        {/* Login Link */}
        <motion.div variants={itemVariants} style={{ textAlign: "center" }}>
          <p style={{ color: getTextSecondary(), fontSize: "0.875rem" }}>
            Already have an account?{" "}
            <Link
              to="/login"
              style={{
                color: "#8b5cf6",
                textDecoration: "none",
                fontWeight: 600,
                transition: "color 0.3s",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#3b82f6")}
              onMouseLeave={(e) => (e.target.style.color = "#8b5cf6")}
            >
              Login here
              <FaArrowRight
                style={{
                  marginLeft: "0.3rem",
                  fontSize: "0.7rem",
                  display: "inline",
                }}
              />
            </Link>
          </p>
        </motion.div>

        {/* Security Badge */}
        <motion.div
          variants={itemVariants}
          style={{
            marginTop: "1.5rem",
            paddingTop: "1rem",
            borderTop: `1px solid ${getBorderColor()}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.5rem",
            flexWrap: "wrap",
          }}
        >
          <FaShieldAlt size={12} color="#10b981" />
          <span style={{ color: getTextSecondary(), fontSize: "0.7rem" }}>
            Your data is protected with 256-bit encryption
          </span>
          <FaStar size={10} color="#f59e0b" />
        </motion.div>
      </motion.div>

      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default Register;
